import { Component, Input, OnInit } from "@angular/core";
import { finalize } from "rxjs/operators";
import { AssemblaTicketService } from "../../models/integrations/assembla-ticket.service";

@Component({
  selector: "ab-assembla-integration",
  templateUrl: "./assembla.component.html",
})
export class AssemblaIntegrationComponent implements OnInit {
  @Input() public notice: any;

  public loading: boolean;
  public ticket: any;
  public creatingTicket: boolean;
  public error: any;
  public removingTicket: boolean;

  constructor(private assemblaTicketService: AssemblaTicketService) {}

  public ngOnInit() {
    this.loading = true;

    return this.assemblaTicketService
      .get(this.notice)
      .pipe(
        finalize(() => {
          delete this.loading;
        }),
      )
      .subscribe((ticket: any) => {
        this.ticket = ticket;
      });
  }

  public createTicket() {
    this.ticket = { notice: this.notice };

    this.creatingTicket = true;
    return this.assemblaTicketService
      .create(this.ticket)
      .pipe(
        finalize(() => {
          delete this.creatingTicket;
        }),
      )
      .subscribe((data: any) => {
        if (data.error) {
          this.error = data.error;
        }
      });
  }

  public removeTicket() {
    this.ticket = { notice: this.notice };

    this.removingTicket = true;
    return this.assemblaTicketService
      .destroy(this.ticket)
      .pipe(
        finalize(() => {
          delete this.removingTicket;
        }),
      )
      .subscribe(() => {
        delete this.ticket;
      });
  }
}
